import React from "react";
import "../App.css";

import MainMenu from "./MainMenu.tsx";
import RectangleManager from "./manager/RectangleManager";
import TodoListManager from "./manager/TodoListManager";
import LayerManager from "./manager/LayerManager";
import { SquareDataProvider } from "./contexts/SquareData";
import { LayerDataProvider } from "./contexts/LayerData";
import { TodoListDataProvider } from "./contexts/TodoListData";

const IndexNoteTool = () => {
  return (
    <div className="dot-grid">
      <LayerDataProvider>
        <SquareDataProvider>
          <TodoListDataProvider>
            <MainMenu />
            <RectangleManager />
            <TodoListManager />
            <LayerManager />
          </TodoListDataProvider>
        </SquareDataProvider>
      </LayerDataProvider>
    </div>
  );
};

export default IndexNoteTool;
